import * as types from './mutation-types'

const defaultForm = () => ({
  id: null,
  name: '',
  slug: '',
  description: '',
  settings: {},
  status: true,
  submit_text: 'Enviar',
  success_title: '',
  success_message: ''
})

export default {
  [types.SET_FORMS] (state, payload) {
    state.forms = payload.data || []
    state.pagination = payload.meta?.pagination || {}
  },

  [types.SET_FORM] (state, payload) {
    state.form = payload || defaultForm()
  },

  [types.SET_FIELDS] (state, payload) {
    state.fields = payload || []
  },

  [types.SET_FIELD_TYPES] (state, payload) {
    state.fieldTypes = payload || []
  },

  [types.SET_FIELD_TYPES_GROUPED] (state, payload) {
    state.fieldTypesGrouped = payload || []
  },

  [types.SET_SELECTED_FIELD] (state, payload) {
    state.selectedField = payload
  },

  [types.SET_CONDITIONS] (state, payload) {
    state.conditions = payload || []
  },

  [types.SET_OPERATORS] (state, payload) {
    state.operators = payload || []
  },

  [types.SET_ACTIONS] (state, payload) {
    state.actions = payload || []
  },

  [types.SET_IS_DIRTY] (state, payload) {
    state.isDirty = payload
  },

  [types.SET_IS_LOADING] (state, payload) {
    state.isLoading = payload
  },

  // ========== LOCAL FIELD MUTATIONS ==========

  [types.ADD_FIELD] (state, payload) {
    state.fields.push(payload)
    state.isDirty = true
  },

  [types.UPDATE_FIELD] (state, payload) {
    const index = state.fields.findIndex(f =>
      (f.id && f.id === payload.id) || (f._tempId && f._tempId === payload._tempId)
    )
    if (index !== -1) {
      state.fields.splice(index, 1, payload)
    }
    state.isDirty = true
  },

  [types.REMOVE_FIELD] (state, payload) {
    const fieldId = payload.id || payload._tempId
    state.fields = state.fields.filter(f =>
      (f.id !== fieldId) && (f._tempId !== fieldId)
    )
    // Remove conditions targeting this field
    state.conditions = state.conditions.filter(c =>
      c.target_field_id !== fieldId
    )
    state.isDirty = true
  },

  [types.REORDER_FIELDS] (state, payload) {
    state.fields = payload
    state.isDirty = true
  },

  // ========== LOCAL CONDITION MUTATIONS ==========

  [types.ADD_CONDITION] (state, payload) {
    state.conditions.push(payload)
    state.isDirty = true
  },

  [types.UPDATE_CONDITION] (state, payload) {
    const index = state.conditions.findIndex(c =>
      (c.id && c.id === payload.id) || (c._tempId && c._tempId === payload._tempId)
    )
    if (index !== -1) {
      state.conditions.splice(index, 1, payload)
    }
    state.isDirty = true
  },

  [types.REMOVE_CONDITION] (state, payload) {
    const conditionId = payload.id || payload._tempId
    state.conditions = state.conditions.filter(c =>
      (c.id !== conditionId) && (c._tempId !== conditionId)
    )
    state.isDirty = true
  }
}
